import  JWT  from "./JWT";
import JWTVerifier from "./JWTVerifier";
import JWTSigner from "./JWTSigner";



const MOObjectUtils = (require("./utils/MOObjectUtils"));
const MOStringUtils = (require("./utils/MOStringUtils"));

 export default class JWTBuilder   {
    constructor(){
        this.header = {
            typ: 'JWT',
            cty: 'JWT'
        };
        this.payload = {};
        this.createdJwt = new JWT()
        this.secret = "";
    }

    parseJwt(jwt) {
        let parts = jwt.split(".");
        if (parts.length != 3) {
            return new JWT();
        }
        let parsedJwt = new JWT();
        parsedJwt.setHeader(parsedJwt.parseStringComponent(parts[0]));
        parsedJwt.setPayload(parsedJwt.parseStringComponent(parts[1]));
        parsedJwt.setSign(parts[2]);
        this.createdJwt = parsedJwt;
        this.header = parsedJwt.getHeader();
        this.payload = parsedJwt.getPayload();
        return parsedJwt;
    }
    generateSecret(length) {
        this.setAlg("HS256");
        let generatedSecret = MOStringUtils.default.generateRandStr(length);
        this.setSecret(generatedSecret);
        return generatedSecret;
    }
    isEmpty() {
        if (MOObjectUtils.default.isEmpty(this.header)) {
            return true;
        }
        if (MOObjectUtils.default.isEmpty(this.payload)) {
            return true;
        }
        return false;
    }
    createJwt() {
        if (!this.createdJwt.isEmpty()) {
            return this.getSignedJWT();
        }
        if (this.isEmpty()) {
            throw new Error("Attributes required to create a JWT are empty.");
        }
        let jwt = new JWT();
        jwt.setHeader(this.header);
        jwt.setPayload(this.payload);
        this.createdJwt = jwt;
        return this.getSignedJWT();
    }
    getSignedJWT() {
        if (this.createdJwt.isEmpty()) {
            throw new Error("Attributes required to create a JWT are empty.");
        }
        let alg = this.createdJwt.getAlg();
        if (MOStringUtils.isEmpty(alg)) {
            throw new Error("Cannot determine algorithm to sign the JWT");
        }
        let jwtSigner = new JWTSigner(this.createdJwt,this.secret);
        return jwtSigner.prepare().sign().getSignedJwt();
    }
    verifyJwt() {
        if (this.createdJwt.isEmpty()) {
            throw new Error("Attributes required to verify a JWT are empty.");
        }
        if (MOStringUtils.default.isEmpty(this.secret)) {
            throw new Error("Cannot verify JWT without secret key.");
        }
        let jwtVerifier = new JWTVerifier(this.createdJwt, this.secret);
        return jwtVerifier.prepare().verify()
    }
    getJwt() {
        return this.createdJwt;
    }
    setJti(jwtId) {
        this.addClaim('jti', jwtId);
        return this;
    }
    setAlg(alg) {
        this.header['alg'] = alg;
        return this;
    }
    setSub(sub) {
        return this.addClaim('sub', sub);
    }
    setIssuer(issuer) {
        return this.addClaim('iss', issuer);
    }
    setAudience(aud) {
        return this.addClaim('aud', aud);
    }
    setIssueTime(iat) {
        return this.addClaim('iat', iat);
    }
    setExpiry(exp) {
        return this.addClaim('exp', exp);
    }
    setNotBefore(nbf) {
        this.addClaim('nbf', nbf);
    }
    setSecret(secret) {
        this.secret = secret;
    }
    addClaim(key, value) {
        this.payload[key] = value;
    }
    getHeader() {
        return this.header;
    }
    getPayload() {
        return this.payload;
    }
}